import { render, staticRenderFns } from "./DeleteObjectForm.vue?vue&type=template&id=1811d74e&lang=html"
import script from "./DeleteObjectForm.vue?vue&type=script&lang=js"
export * from "./DeleteObjectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports